import { render, staticRenderFns } from "./taskallocation.vue?vue&type=template&id=d5233df0&"
import script from "./taskallocation.vue?vue&type=script&lang=js&"
export * from "./taskallocation.vue?vue&type=script&lang=js&"
import style0 from "./taskallocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports